import { EnumValue } from "types/enums/customEnum";

export enum SplitProfileScenario {
	StraightSplit,
	Override,
	Waterfall,
}

type SplitInformationType = {
	agentId: string;
	partnerType: EnumValue;
	splitPercent: number;
};

type SplitProfileType = {
	scenario: SplitProfileScenario;
	totalRevenueShare: number;
	primaryInformation: SplitInformationType;
	secondaryInformation?: SplitInformationType[];
	waterfallAmountBeforeSplit?: number; //used only for Waterfall calculation as temporary storage
};

type CreateCalculatedRecordPropsType = {
	totalProfitOrLoss: number;
	splitProfile: SplitProfileType;
	agentId: string;
	partnerType: EnumValue;
	splitPercent: number;
};

type CalculatedRecordType = {
	agentId: string;
	payoutAmountBeforeAdjustments: number;
	residualsAmountBeforeSplit: number;
};

//-----------
// Core functions
//-----------

export function residualsCalculator(
	totalProfitOrLoss: number,
	splitProfile: SplitProfileType,
): CalculatedRecordType[] {
	var calculatedRecords: CalculatedRecordType[] = [];
	var primaryInfo = splitProfile.primaryInformation;

	var primaryAgentCalculatedRecord = createCalculatedRecord({
		totalProfitOrLoss: totalProfitOrLoss,
		splitProfile: splitProfile,
		agentId: primaryInfo.agentId,
		partnerType: primaryInfo.partnerType,
		splitPercent: primaryInfo.splitPercent,
	});
	calculatedRecords.push(primaryAgentCalculatedRecord);

	if (
		splitProfile.scenario === SplitProfileScenario.Override ||
		splitProfile.scenario === SplitProfileScenario.Waterfall
	) {
		splitProfile.secondaryInformation?.forEach(function (secondaryInfo) {
			var secondaryAgentCalculatedRecord = createCalculatedRecord({
				totalProfitOrLoss: totalProfitOrLoss,
				splitProfile: splitProfile,
				agentId: secondaryInfo.agentId,
				partnerType: secondaryInfo.partnerType,
				splitPercent: secondaryInfo.splitPercent,
			});
			calculatedRecords.push(secondaryAgentCalculatedRecord);
		});
	}

	return calculatedRecords;
}

function createCalculatedRecord({
	totalProfitOrLoss,
	splitProfile,
	agentId,
	partnerType,
	splitPercent,
}: CreateCalculatedRecordPropsType): CalculatedRecordType {
	var record: CalculatedRecordType = {
		agentId: agentId,
		payoutAmountBeforeAdjustments: 0,
		residualsAmountBeforeSplit: 0,
	};

	if (
		splitProfile.scenario === SplitProfileScenario.StraightSplit ||
		splitProfile.scenario === SplitProfileScenario.Override
	) {
		record.residualsAmountBeforeSplit = totalProfitOrLoss;

		record.payoutAmountBeforeAdjustments =
			record.residualsAmountBeforeSplit * (splitPercent / 100.0);
	} else if (splitProfile.scenario === SplitProfileScenario.Waterfall) {
		if (typeof splitProfile.waterfallAmountBeforeSplit === "undefined") {
			splitProfile.waterfallAmountBeforeSplit =
				totalProfitOrLoss * (splitProfile.totalRevenueShare / 100.0);
		}

		record.residualsAmountBeforeSplit =
			splitProfile.waterfallAmountBeforeSplit;

		record.payoutAmountBeforeAdjustments =
			record.residualsAmountBeforeSplit * (splitPercent / 100.0);

		splitProfile.waterfallAmountBeforeSplit -=
			record.payoutAmountBeforeAdjustments;
	}

	return record;
}
